module.exports = __webpack_public_path__ + "static/media/google-data-studio.b738238f.png";